import { IValidationRule } from "@/types"

const assetTypeValidationRules: { [s: string]: IValidationRule } = {
    productType: {
        required: true,
        type: "integer",
        min: 0,
        max: 9,
    },
    description: {
        required: true,
    }
}

export default assetTypeValidationRules
